import * as React from "react";
const SvgFiRrBanana = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-banana_svg__a)">
      <path
        fill="#062147"
        d="M23.892 15.043c-.867-1.651-2.51-3.144-4.127-3.865C19.73 3.576 18.397.018 15.57.008h-.013c-3.131 0-4.314 4.119-4.891 8.38-.32-.107-.67-.2-1.101-.273a8.05 8.05 0 0 0-5.446 1c-.358.212-.504.657-.38 1.053l.012.037a.92.92 0 0 0 1.037.633c2.628-.477 4.033.033 5.286 1.396-.494 1.613-1.67 3.907-4.471 5.31-2.745 1.182-3.813 3.107-3.976 3.428l-.611-.01H1a.999.999 0 0 0-.017 1.999l.614.01C2.057 23.998 4.074 24 4.999 24c4.429 0 7.512-1.196 9.66-2.795a.98.98 0 0 0 .38-.877l-.002-.027c-.076-.756-.943-1.175-1.55-.718C11.362 21.183 8.528 22 5 22c-.764 0-1.23-.05-1.5-.096v-.184c.269-.433 1.114-1.574 2.947-2.365 2.823-1.411 4.312-3.54 5.1-5.354 2.47.432 5.062 1.075 5.517 6.459a.93.93 0 0 0 .674.83c.438.122.914-.088 1.089-.508.815-1.966 1.043-4.05.53-5.871.923.153 2.147.747 3.182 1.376a.94.94 0 0 0 .994.005l.039-.025a.935.935 0 0 0 .32-1.225m-8.893-2.956c-.606-.038-2.267-.532-2.471-2.466.729-6.25 2.037-7.612 3.03-7.612h.005c.985.004 2.125 2.34 2.198 8.797-.207.386-.885 1.282-2.762 1.282z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-banana_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBanana;
